/**
 * @generated SignedSource<<2fe4c6714c7bf2041496f34b2c4436d3>>
 * @relayHash 1782ec4f898bc4f01d0c3dfecf8aaa0c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 03cc9518ccb0bf1466848860b75bba3c6e89dff5dc57df669f6c656d0374beb7

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PTGraphQLPageStatus = "CURRENT" | "DRAFT" | "HISTORICAL" | "TRASHED" | "%future added value";
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type SpaceSidebarLinkType = "EXTERNAL_LINK" | "FORGE" | "PINNED_ATTACHMENT" | "PINNED_BLOG_POST" | "PINNED_PAGE" | "PINNED_SPACE" | "PINNED_USER_INFO" | "WEB_ITEM" | "%future added value";
export type SpaceNavigationQuery$variables = {
  blogFirst?: number | null;
  blogOrderBy?: string | null;
  blogStatuses?: ReadonlyArray<string | null> | null;
  cloudId: string;
  contentId?: string | null;
  includeBlogTree?: boolean | null;
  includeHomepageTreeVariant?: boolean | null;
  includePageTree?: boolean | null;
  includePersistentInviteLicense?: boolean | null;
  includeSpaceCurationCount?: boolean | null;
  includeSpaceViewsPersistence?: boolean | null;
  isLicensed: boolean;
  isSuperAdmin?: boolean | null;
  paginationLimit?: number | null;
  ptStatuses?: ReadonlyArray<PTGraphQLPageStatus | null> | null;
  spaceKey: string;
};
export type SpaceNavigationQuery$data = {
  readonly blogPosts?: {
    readonly nodes: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"BlogTreeRootComponent_content">;
    } | null> | null;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    } | null;
  } | null;
  readonly currentPage?: {
    readonly children: {
      readonly nodes: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly followingSiblings: {
      readonly nodes: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly nearestAncestors: {
      readonly nodes: ReadonlyArray<{
        readonly followingSiblings: {
          readonly nodes: ReadonlyArray<{
            readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
          } | null> | null;
          readonly pageInfo: {
            readonly hasNextPage: boolean;
          } | null;
        } | null;
        readonly previousSiblings: {
          readonly nodes: ReadonlyArray<{
            readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
          } | null> | null;
          readonly pageInfo: {
            readonly hasNextPage: boolean;
          } | null;
        } | null;
        readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
      } | null> | null;
      readonly pageInfo: {
        readonly endCursor: string | null;
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly previousSiblings: {
      readonly nodes: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
  } | null;
  readonly homepageRootPageTree?: {
    readonly followingSiblings: {
      readonly nodes: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
  } | null;
  readonly license?: {
    readonly " $fragmentSpreads": FragmentRefs<"PersistentInviteEligibleQuery_license">;
  } | null;
  readonly rootPageTree?: {
    readonly followingSiblings: {
      readonly nodes: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
  } | null;
  readonly space: {
    readonly containsExternalCollaborators: boolean;
    readonly currentUser?: {
      readonly isAdmin: boolean;
      readonly isFavourited: boolean;
      readonly isWatched: boolean;
    };
    readonly didContainUserContent: boolean;
    readonly history: {
      readonly createdDate: string | null;
    } | null;
    readonly homepage: {
      readonly id: string | null;
    } | null;
    readonly homepageId: string | null;
    readonly icon: {
      readonly path: string;
    } | null;
    readonly id: string | null;
    readonly key: string | null;
    readonly name: string | null;
    readonly operations: ReadonlyArray<{
      readonly operation: string | null;
      readonly targetType: string | null;
    } | null> | null;
    readonly pageTree?: {
      readonly children: {
        readonly nodes: ReadonlyArray<{
          readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
        } | null> | null;
        readonly pageInfo: {
          readonly hasNextPage: boolean;
        } | null;
      } | null;
      readonly followingSiblings: {
        readonly nodes: ReadonlyArray<{
          readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
        } | null> | null;
        readonly pageInfo: {
          readonly hasNextPage: boolean;
        } | null;
      } | null;
      readonly nearestAncestors: {
        readonly nodes: ReadonlyArray<{
          readonly followingSiblings: {
            readonly nodes: ReadonlyArray<{
              readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
            } | null> | null;
            readonly pageInfo: {
              readonly hasNextPage: boolean;
            } | null;
          } | null;
          readonly previousSiblings: {
            readonly nodes: ReadonlyArray<{
              readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
            } | null> | null;
            readonly pageInfo: {
              readonly hasNextPage: boolean;
            } | null;
          } | null;
          readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
        } | null> | null;
        readonly pageInfo: {
          readonly endCursor: string | null;
          readonly hasNextPage: boolean;
        } | null;
      } | null;
      readonly previousSiblings: {
        readonly nodes: ReadonlyArray<{
          readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
        } | null> | null;
        readonly pageInfo: {
          readonly hasNextPage: boolean;
        } | null;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
    } | null;
    readonly status: string | null;
    readonly type: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"ExternalCollaboratorsSpaceInformationMessage_space" | "PersistentInviteEligibleQuery_space" | "SpaceHeader_space" | "SpaceOperationsFragment" | "useIsUserViewingSpaceAsAnon_space" | "useSpaceViewsData_space">;
  } | null;
  readonly spaceCurationSuggestionCount?: {
    readonly " $fragmentSpreads": FragmentRefs<"useFetchSuggestionCount_query">;
  } | null;
  readonly spaceSidebarLinks: {
    readonly main: ReadonlyArray<{
      readonly canHide: boolean | null;
      readonly hidden: boolean;
      readonly icon: {
        readonly height: number | null;
        readonly isDefault: boolean | null;
        readonly path: string;
        readonly width: number | null;
      } | null;
      readonly iconClass: string | null;
      readonly id: string;
      readonly linkIdentifier: string | null;
      readonly position: number;
      readonly styleClass: string | null;
      readonly title: string | null;
      readonly tooltip: string | null;
      readonly type: SpaceSidebarLinkType;
      readonly url: string | null;
      readonly webItemCompleteKey: string | null;
      readonly webItemKey: string | null;
    } | null> | null;
    readonly quick: ReadonlyArray<{
      readonly id: string;
      readonly position: number;
      readonly styleClass: string | null;
      readonly title: string | null;
      readonly url: string | null;
    } | null> | null;
    readonly " $fragmentSpreads": FragmentRefs<"ShortcutsSection_spaceSidebarLinks" | "SpaceLinks_spaceSidebarLinks">;
  } | null;
  readonly user: {
    readonly confluence: {
      readonly permissionType: SitePermissionType | null;
    } | null;
    readonly id: string | null;
  } | null;
  readonly userPreferences?: {
    readonly " $fragmentSpreads": FragmentRefs<"useSpaceViewsOptionsPersistence_userPreferences">;
  } | null;
};
export type SpaceNavigationQuery = {
  response: SpaceNavigationQuery$data;
  variables: SpaceNavigationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": 40,
  "kind": "LocalArgument",
  "name": "blogFirst"
},
v1 = {
  "defaultValue": "metadata.createdDate desc",
  "kind": "LocalArgument",
  "name": "blogOrderBy"
},
v2 = {
  "defaultValue": [
    "current",
    "draft"
  ],
  "kind": "LocalArgument",
  "name": "blogStatuses"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v5 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeBlogTree"
},
v6 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeHomepageTreeVariant"
},
v7 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includePageTree"
},
v8 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includePersistentInviteLicense"
},
v9 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeSpaceCurationCount"
},
v10 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeSpaceViewsPersistence"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isLicensed"
},
v12 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isSuperAdmin"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "paginationLimit"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ptStatuses"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v16 = {
  "kind": "ScalarField",
  "name": "id"
},
v17 = {
  "alias": "user",
  "args": [
    {
      "kind": "Literal",
      "name": "current",
      "value": true
    }
  ],
  "concreteType": "AtlassianUser",
  "kind": "LinkedField",
  "name": "confluence_atlassianUser",
  "plural": false,
  "selections": [
    (v16/*: any*/),
    {
      "concreteType": "ConfluenceUser",
      "kind": "LinkedField",
      "name": "confluence",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "permissionType"
        }
      ]
    }
  ],
  "storageKey": "confluence_atlassianUser(current:true)"
},
v18 = {
  "kind": "Variable",
  "name": "spaceKey",
  "variableName": "spaceKey"
},
v19 = [
  (v18/*: any*/)
],
v20 = [
  {
    "kind": "Literal",
    "name": "includeHidden",
    "value": true
  }
],
v21 = {
  "kind": "ScalarField",
  "name": "webItemKey"
},
v22 = {
  "kind": "ScalarField",
  "name": "webItemCompleteKey"
},
v23 = {
  "kind": "ScalarField",
  "name": "title"
},
v24 = {
  "kind": "ScalarField",
  "name": "url"
},
v25 = {
  "kind": "ScalarField",
  "name": "position"
},
v26 = {
  "kind": "ScalarField",
  "name": "styleClass"
},
v27 = {
  "kind": "ScalarField",
  "name": "path"
},
v28 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v27/*: any*/),
    {
      "kind": "ScalarField",
      "name": "width"
    },
    {
      "kind": "ScalarField",
      "name": "height"
    },
    {
      "kind": "ScalarField",
      "name": "isDefault"
    }
  ]
},
v29 = {
  "kind": "ScalarField",
  "name": "iconClass"
},
v30 = {
  "kind": "ScalarField",
  "name": "hidden"
},
v31 = {
  "kind": "ScalarField",
  "name": "canHide"
},
v32 = {
  "kind": "ScalarField",
  "name": "tooltip"
},
v33 = {
  "kind": "ScalarField",
  "name": "linkIdentifier"
},
v34 = {
  "kind": "ScalarField",
  "name": "type"
},
v35 = {
  "concreteType": "SpaceSidebarLink",
  "kind": "LinkedField",
  "name": "quick",
  "plural": true,
  "selections": [
    (v16/*: any*/),
    (v24/*: any*/),
    (v25/*: any*/),
    (v23/*: any*/),
    (v26/*: any*/)
  ]
},
v36 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "spaceKey"
  }
],
v37 = {
  "kind": "ScalarField",
  "name": "key"
},
v38 = {
  "concreteType": "Content",
  "kind": "LinkedField",
  "name": "homepage",
  "plural": false,
  "selections": [
    (v16/*: any*/)
  ]
},
v39 = {
  "concreteType": "OperationCheckResult",
  "kind": "LinkedField",
  "name": "operations",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "operation"
    },
    {
      "kind": "ScalarField",
      "name": "targetType"
    }
  ]
},
v40 = {
  "kind": "ScalarField",
  "name": "didContainUserContent"
},
v41 = {
  "kind": "ScalarField",
  "name": "name"
},
v42 = {
  "kind": "ScalarField",
  "name": "status"
},
v43 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v27/*: any*/)
  ]
},
v44 = {
  "kind": "ScalarField",
  "name": "homepageId"
},
v45 = {
  "kind": "ScalarField",
  "name": "isAdmin"
},
v46 = {
  "kind": "ScalarField",
  "name": "isFavourited"
},
v47 = {
  "kind": "ScalarField",
  "name": "isWatched"
},
v48 = {
  "kind": "ScalarField",
  "name": "containsExternalCollaborators"
},
v49 = {
  "kind": "ScalarField",
  "name": "createdDate"
},
v50 = {
  "concreteType": "SpaceHistory",
  "kind": "LinkedField",
  "name": "history",
  "plural": false,
  "selections": [
    (v49/*: any*/)
  ]
},
v51 = {
  "kind": "Literal",
  "name": "enablePaging",
  "value": true
},
v52 = {
  "kind": "Variable",
  "name": "pageTree",
  "variableName": "paginationLimit"
},
v53 = {
  "kind": "Variable",
  "name": "status",
  "variableName": "ptStatuses"
},
v54 = [
  (v51/*: any*/),
  (v52/*: any*/),
  (v53/*: any*/)
],
v55 = {
  "kind": "FragmentSpread",
  "name": "PageTreeQuery_ptpage"
},
v56 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v57 = [
  (v56/*: any*/),
  {
    "kind": "ScalarField",
    "name": "endCursor"
  }
],
v58 = {
  "concreteType": "PTPageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": (v57/*: any*/)
},
v59 = {
  "concreteType": "PTPageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v56/*: any*/)
  ]
},
v60 = [
  {
    "concreteType": "PTPage",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v55/*: any*/)
    ]
  },
  (v59/*: any*/)
],
v61 = {
  "concreteType": "PTPaginatedPageList",
  "kind": "LinkedField",
  "name": "previousSiblings",
  "plural": false,
  "selections": (v60/*: any*/)
},
v62 = {
  "concreteType": "PTPaginatedPageList",
  "kind": "LinkedField",
  "name": "followingSiblings",
  "plural": false,
  "selections": (v60/*: any*/)
},
v63 = [
  (v55/*: any*/),
  {
    "concreteType": "PTPaginatedPageList",
    "kind": "LinkedField",
    "name": "nearestAncestors",
    "plural": false,
    "selections": [
      (v58/*: any*/),
      {
        "concreteType": "PTPage",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v55/*: any*/),
          (v61/*: any*/),
          (v62/*: any*/)
        ]
      }
    ]
  },
  (v61/*: any*/),
  (v62/*: any*/),
  {
    "concreteType": "PTPaginatedPageList",
    "kind": "LinkedField",
    "name": "children",
    "plural": false,
    "selections": (v60/*: any*/)
  }
],
v64 = [
  (v51/*: any*/),
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  },
  (v52/*: any*/),
  (v18/*: any*/),
  (v53/*: any*/)
],
v65 = [
  (v51/*: any*/),
  (v52/*: any*/),
  (v18/*: any*/),
  (v53/*: any*/)
],
v66 = [
  (v55/*: any*/),
  (v62/*: any*/)
],
v67 = [
  (v18/*: any*/),
  (v53/*: any*/)
],
v68 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "blogFirst"
  },
  {
    "kind": "Variable",
    "name": "orderby",
    "variableName": "blogOrderBy"
  },
  (v18/*: any*/),
  {
    "kind": "Variable",
    "name": "status",
    "variableName": "blogStatuses"
  },
  {
    "kind": "Literal",
    "name": "type",
    "value": "blogpost"
  }
],
v69 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": (v57/*: any*/)
},
v70 = {
  "kind": "ScalarField",
  "name": "value"
},
v71 = {
  "args": [
    {
      "kind": "Literal",
      "name": "format",
      "value": "MILLIS"
    }
  ],
  "concreteType": "ConfluenceDate",
  "kind": "LinkedField",
  "name": "createdDate",
  "plural": false,
  "selections": [
    (v70/*: any*/)
  ],
  "storageKey": "createdDate(format:\"MILLIS\")"
},
v72 = {
  "kind": "ScalarField",
  "name": "hasChildren"
},
v73 = {
  "kind": "ScalarField",
  "name": "blank"
},
v74 = {
  "condition": "isSuperAdmin",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasRestrictions"
    },
    {
      "kind": "ScalarField",
      "name": "hasInheritedRestrictions"
    }
  ]
},
v75 = {
  "kind": "ScalarField",
  "name": "subType"
},
v76 = [
  {
    "kind": "ScalarField",
    "name": "webui"
  }
],
v77 = {
  "concreteType": "Map_LinkType_String",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": (v76/*: any*/)
},
v78 = [
  {
    "kind": "Literal",
    "name": "keys",
    "value": [
      "emoji-title-published",
      "emoji-title-draft",
      "editor"
    ]
  }
],
v79 = {
  "args": (v78/*: any*/),
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v16/*: any*/),
        (v37/*: any*/),
        (v70/*: any*/),
        {
          "concreteType": "Version",
          "kind": "LinkedField",
          "name": "version",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "number"
            }
          ]
        }
      ]
    }
  ],
  "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
},
v80 = [
  {
    "concreteType": "PTPage",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v16/*: any*/),
      (v23/*: any*/),
      (v42/*: any*/),
      (v71/*: any*/),
      (v72/*: any*/),
      (v73/*: any*/),
      (v74/*: any*/),
      (v34/*: any*/),
      (v75/*: any*/),
      (v77/*: any*/),
      (v79/*: any*/)
    ]
  },
  (v59/*: any*/)
],
v81 = {
  "concreteType": "PTPaginatedPageList",
  "kind": "LinkedField",
  "name": "previousSiblings",
  "plural": false,
  "selections": (v80/*: any*/)
},
v82 = {
  "concreteType": "PTPaginatedPageList",
  "kind": "LinkedField",
  "name": "followingSiblings",
  "plural": false,
  "selections": (v80/*: any*/)
},
v83 = [
  (v16/*: any*/),
  (v23/*: any*/),
  (v42/*: any*/),
  (v71/*: any*/),
  (v72/*: any*/),
  (v73/*: any*/),
  (v74/*: any*/),
  (v34/*: any*/),
  (v75/*: any*/),
  (v77/*: any*/),
  (v79/*: any*/),
  {
    "concreteType": "PTPaginatedPageList",
    "kind": "LinkedField",
    "name": "nearestAncestors",
    "plural": false,
    "selections": [
      (v58/*: any*/),
      {
        "concreteType": "PTPage",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v16/*: any*/),
          (v23/*: any*/),
          (v42/*: any*/),
          (v71/*: any*/),
          (v72/*: any*/),
          (v73/*: any*/),
          (v74/*: any*/),
          (v34/*: any*/),
          (v75/*: any*/),
          (v77/*: any*/),
          (v79/*: any*/),
          (v81/*: any*/),
          (v82/*: any*/)
        ]
      }
    ]
  },
  (v81/*: any*/),
  (v82/*: any*/),
  {
    "concreteType": "PTPaginatedPageList",
    "kind": "LinkedField",
    "name": "children",
    "plural": false,
    "selections": (v80/*: any*/)
  }
],
v84 = [
  (v16/*: any*/),
  (v23/*: any*/),
  (v42/*: any*/),
  (v71/*: any*/),
  (v72/*: any*/),
  (v73/*: any*/),
  (v74/*: any*/),
  (v34/*: any*/),
  (v75/*: any*/),
  (v77/*: any*/),
  (v79/*: any*/),
  (v82/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/)
    ],
    "kind": "Fragment",
    "name": "SpaceNavigationQuery",
    "selections": [
      (v17/*: any*/),
      {
        "condition": "includeSpaceCurationCount",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "useFetchSuggestionCount_query"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "spaceCurationSuggestionCount"
          }
        ]
      },
      {
        "condition": "includePersistentInviteLicense",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "License",
            "kind": "LinkedField",
            "name": "license",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "PersistentInviteEligibleQuery_license"
              }
            ]
          }
        ]
      },
      {
        "args": (v19/*: any*/),
        "concreteType": "SpaceSidebarLinks",
        "kind": "LinkedField",
        "name": "spaceSidebarLinks",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "SpaceLinks_spaceSidebarLinks"
          },
          {
            "kind": "FragmentSpread",
            "name": "ShortcutsSection_spaceSidebarLinks"
          },
          {
            "args": (v20/*: any*/),
            "concreteType": "SpaceSidebarLink",
            "kind": "LinkedField",
            "name": "main",
            "plural": true,
            "selections": [
              (v16/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/)
            ],
            "storageKey": "main(includeHidden:true)"
          },
          (v35/*: any*/)
        ]
      },
      {
        "args": (v36/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "useIsUserViewingSpaceAsAnon_space"
          },
          {
            "kind": "FragmentSpread",
            "name": "PersistentInviteEligibleQuery_space"
          },
          {
            "kind": "FragmentSpread",
            "name": "ExternalCollaboratorsSpaceInformationMessage_space"
          },
          {
            "args": [
              {
                "kind": "Variable",
                "name": "isLicensed",
                "variableName": "isLicensed"
              }
            ],
            "kind": "FragmentSpread",
            "name": "SpaceHeader_space"
          },
          (v16/*: any*/),
          (v37/*: any*/),
          (v38/*: any*/),
          (v39/*: any*/),
          {
            "kind": "FragmentSpread",
            "name": "SpaceOperationsFragment"
          },
          (v40/*: any*/),
          {
            "kind": "FragmentSpread",
            "name": "useSpaceViewsData_space"
          },
          (v41/*: any*/),
          (v34/*: any*/),
          (v42/*: any*/),
          (v43/*: any*/),
          (v44/*: any*/),
          {
            "condition": "isLicensed",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "SpaceUserMetadata",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  (v45/*: any*/),
                  (v46/*: any*/),
                  (v47/*: any*/)
                ]
              }
            ]
          },
          (v48/*: any*/),
          (v50/*: any*/),
          {
            "condition": "includeHomepageTreeVariant",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v54/*: any*/),
                "concreteType": "PTPage",
                "kind": "LinkedField",
                "name": "pageTree",
                "plural": false,
                "selections": (v63/*: any*/)
              }
            ]
          }
        ]
      },
      {
        "condition": "includePageTree",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "currentPage",
            "args": (v64/*: any*/),
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": (v63/*: any*/)
          },
          {
            "alias": "rootPageTree",
            "args": (v65/*: any*/),
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": (v66/*: any*/)
          }
        ]
      },
      {
        "condition": "includeHomepageTreeVariant",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "homepageRootPageTree",
            "args": (v67/*: any*/),
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": (v66/*: any*/)
          }
        ]
      },
      {
        "condition": "includeBlogTree",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "blogPosts",
            "args": (v68/*: any*/),
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
              (v69/*: any*/),
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "BlogTreeRootComponent_content"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "includeSpaceViewsPersistence",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "useSpaceViewsOptionsPersistence_userPreferences"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v15/*: any*/),
      (v11/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v4/*: any*/),
      (v14/*: any*/),
      (v13/*: any*/),
      (v12/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v10/*: any*/)
    ],
    "kind": "Operation",
    "name": "SpaceNavigationQuery",
    "selections": [
      (v17/*: any*/),
      {
        "args": (v19/*: any*/),
        "concreteType": "SpaceSidebarLinks",
        "kind": "LinkedField",
        "name": "spaceSidebarLinks",
        "plural": false,
        "selections": [
          {
            "args": (v20/*: any*/),
            "concreteType": "SpaceSidebarLink",
            "kind": "LinkedField",
            "name": "main",
            "plural": true,
            "selections": [
              (v16/*: any*/),
              (v22/*: any*/),
              (v25/*: any*/),
              (v30/*: any*/),
              (v21/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v26/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/)
            ],
            "storageKey": "main(includeHidden:true)"
          },
          (v35/*: any*/)
        ]
      },
      {
        "args": (v36/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          (v16/*: any*/),
          {
            "concreteType": "SpaceUserMetadata",
            "kind": "LinkedField",
            "name": "currentUser",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isAnonymouslyAuthorized"
              },
              (v45/*: any*/)
            ]
          },
          (v41/*: any*/),
          {
            "kind": "ScalarField",
            "name": "externalCollaboratorCount"
          },
          (v37/*: any*/),
          (v34/*: any*/),
          (v42/*: any*/),
          (v43/*: any*/),
          (v38/*: any*/),
          (v39/*: any*/),
          (v48/*: any*/),
          (v40/*: any*/),
          (v44/*: any*/),
          (v50/*: any*/),
          {
            "condition": "isLicensed",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "SpaceUserMetadata",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  (v46/*: any*/),
                  (v47/*: any*/)
                ]
              }
            ]
          },
          {
            "condition": "includeHomepageTreeVariant",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v54/*: any*/),
                "concreteType": "PTPage",
                "kind": "LinkedField",
                "name": "pageTree",
                "plural": false,
                "selections": (v83/*: any*/)
              }
            ]
          }
        ]
      },
      {
        "condition": "includeSpaceCurationCount",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
              },
              (v18/*: any*/)
            ],
            "kind": "ScalarField",
            "name": "confluence_remoteObjectSuggestionCount"
          }
        ]
      },
      {
        "condition": "includePersistentInviteLicense",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "License",
            "kind": "LinkedField",
            "name": "license",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "licenseConsumingUserCount"
              },
              {
                "kind": "ScalarField",
                "name": "trialEndDate"
              }
            ]
          }
        ]
      },
      {
        "condition": "includePageTree",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "currentPage",
            "args": (v64/*: any*/),
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": (v83/*: any*/)
          },
          {
            "alias": "rootPageTree",
            "args": (v65/*: any*/),
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": (v84/*: any*/)
          }
        ]
      },
      {
        "condition": "includeHomepageTreeVariant",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "homepageRootPageTree",
            "args": (v67/*: any*/),
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": (v84/*: any*/)
          }
        ]
      },
      {
        "condition": "includeBlogTree",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "blogPosts",
            "args": (v68/*: any*/),
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
              (v69/*: any*/),
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v16/*: any*/),
                  (v23/*: any*/),
                  (v42/*: any*/),
                  (v73/*: any*/),
                  {
                    "args": (v78/*: any*/),
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JsonContentProperty",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v16/*: any*/),
                          (v37/*: any*/),
                          (v70/*: any*/)
                        ]
                      }
                    ],
                    "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
                  },
                  {
                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": (v76/*: any*/)
                  },
                  {
                    "concreteType": "ContentMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "lastModifiedDate"
                      },
                      (v49/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "includeSpaceViewsPersistence",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
              {
                "args": (v19/*: any*/),
                "kind": "ScalarField",
                "name": "spaceViewsPersistence"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "1782ec4f898bc4f01d0c3dfecf8aaa0c",
    "id": "03cc9518ccb0bf1466848860b75bba3c6e89dff5dc57df669f6c656d0374beb7",
    "metadata": {},
    "name": "SpaceNavigationQuery",
    "operationKind": "query",
    "text": "query SpaceNavigationQuery($cloudId:ID!,$spaceKey:String!,$isLicensed:Boolean!,$includePersistentInviteLicense:Boolean=false,$includeSpaceCurationCount:Boolean=false,$contentId:ID,$ptStatuses:[PTGraphQLPageStatus],$paginationLimit:Int,$isSuperAdmin:Boolean=false,$includePageTree:Boolean=false,$includeHomepageTreeVariant:Boolean=false,$includeBlogTree:Boolean=false,$blogFirst:Int=40,$blogOrderBy:String=\"metadata.createdDate desc\",$blogStatuses:[String]=[\"current\",\"draft\"],$includeSpaceViewsPersistence:Boolean=false){user:confluence_atlassianUser(current:true){id,confluence{permissionType}},...useFetchSuggestionCount_query@include(if:$includeSpaceCurationCount),license@include(if:$includePersistentInviteLicense){...PersistentInviteEligibleQuery_license},spaceSidebarLinks(spaceKey:$spaceKey){...SpaceLinks_spaceSidebarLinks,...ShortcutsSection_spaceSidebarLinks,main(includeHidden:true){id,webItemKey,webItemCompleteKey,title,url,position,styleClass,icon{path,width,height,isDefault},iconClass,hidden,canHide,tooltip,linkIdentifier,type},quick{id,url,position,title,styleClass}},space(key:$spaceKey){...useIsUserViewingSpaceAsAnon_space,...PersistentInviteEligibleQuery_space,...ExternalCollaboratorsSpaceInformationMessage_space,...SpaceHeader_space_3F1fcg,id,key,homepage{id},operations{operation,targetType},...SpaceOperationsFragment,didContainUserContent,...useSpaceViewsData_space,name,type,status,icon{path},homepageId,currentUser@include(if:$isLicensed){isAdmin,isFavourited,isWatched},containsExternalCollaborators,history{createdDate},pageTree(pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true)@include(if:$includeHomepageTreeVariant){...PageTreeQuery_ptpage,nearestAncestors{pageInfo{hasNextPage,endCursor},nodes{...PageTreeQuery_ptpage,previousSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id}},previousSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},children{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id}},currentPage:ptpage(id:$contentId,spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true)@include(if:$includePageTree){...PageTreeQuery_ptpage,nearestAncestors{pageInfo{hasNextPage,endCursor},nodes{...PageTreeQuery_ptpage,previousSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id}},previousSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},children{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id}\n  rootPageTree:ptpage(spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true)@include(if:$includePageTree){...PageTreeQuery_ptpage,followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id},homepageRootPageTree:ptpage(spaceKey:$spaceKey,status:$ptStatuses)@include(if:$includeHomepageTreeVariant){...PageTreeQuery_ptpage,followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id},blogPosts:content(spaceKey:$spaceKey,type:\"blogpost\",first:$blogFirst,orderby:$blogOrderBy,status:$blogStatuses)@include(if:$includeBlogTree){pageInfo{hasNextPage,endCursor},nodes{...BlogTreeRootComponent_content,id}},userPreferences@include(if:$includeSpaceViewsPersistence){...useSpaceViewsOptionsPersistence_userPreferences}}fragment BlogTreeRootComponent_content on Content{id,title,status,blank,properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value}},links{webui},metadata{lastModifiedDate,createdDate}}fragment ExternalCollaboratorsSpaceInformationMessage_space on Space{id,name,externalCollaboratorCount,currentUser{isAdmin}}fragment PageTreeQuery_ptpage on PTPage{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n  hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}}fragment PersistentInviteEligibleQuery_license on License{licenseConsumingUserCount,trialEndDate}fragment PersistentInviteEligibleQuery_space on Space{id,currentUser{isAnonymouslyAuthorized}}fragment ShortcutsSection_spaceSidebarLinks on SpaceSidebarLinks{quick{id,url,position,title,styleClass}}fragment SpaceHeader_space_3F1fcg on Space{id,key,name,type,status,icon{path},homepage{id},currentUser@include(if:$isLicensed){isAdmin,isFavourited,isWatched},operations{operation,targetType},containsExternalCollaborators}fragment SpaceLinks_spaceSidebarLinks on SpaceSidebarLinks{main(includeHidden:true){id,webItemCompleteKey,position,hidden}}fragment SpaceOperationsFragment on Space{id,operations{operation,targetType}}fragment useFetchSuggestionCount_query on Query{confluence_remoteObjectSuggestionCount(cloudId:$cloudId,spaceKey:$spaceKey)}fragment useIsUserViewingSpaceAsAnon_space on Space{id,currentUser{isAnonymouslyAuthorized}}fragment useSpaceViewsData_space on Space{id,homepage{id},operations{operation,targetType}}fragment useSpaceViewsOptionsPersistence_userPreferences on UserPreferences{spaceViewsPersistence(spaceKey:$spaceKey)}"
  }
};
})();

(node as any).hash = "a132fccca933dc0b529b187287efa584";

export default node;
